export default __webpack_public_path__ + "static/media/move-material-3.78282ae2.webp";